import React from "react";

import { MyTransfersWrapper } from "../../components";

export default function MyTransfersPage() {
  return <MyTransfersWrapper />;
}
